import type { DefaultOptions } from '@tanstack/react-query';

import {
  QueryClient,
  defaultShouldDehydrateQuery,
} from '@tanstack/react-query';
import superjson from 'superjson';

export const createQueryClient = (options?: DefaultOptions) =>
  new QueryClient({
    defaultOptions: {
      dehydrate: {
        serializeData: superjson.serialize,
        shouldDehydrateQuery: (query) =>
          defaultShouldDehydrateQuery(query) ||
          query.state.status === 'pending',
      },
      hydrate: {
        deserializeData: superjson.deserialize,
      },
      queries: {
        // With SSR, we usually want to set some default staleTime
        // above 0 to avoid refetching immediately on the client
        staleTime: 30 * 1000,
      },
      ...options,
    },
  });
